import { Injectable } from "@angular/core";

import PouchDB from "pouchdb";
import PouchDBUpsert from "pouchdb-upsert";
import PouchDBAuthentication from "pouchdb-authentication";

import { environment } from "src/environments/environment";
import { formatISO } from "date-fns";

PouchDB.plugin(PouchDBUpsert);
PouchDB.plugin(PouchDBAuthentication);

@Injectable({
  providedIn: "root",
})
export class DbService {
  private _localDB: PouchDB.Database;
  private sync: any;

  constructor() {
    this._localDB = new PouchDB(`${environment.COUCHDB.DB_NAME}`);
    this._remoteDB = new PouchDB(
      `${environment.COUCHDB.URL}/${environment.COUCHDB.DB_NAME}`,
      {
        skip_setup: true,
        fetch: async (url: any, opts: any) =>
          fetch(url, {
            ...opts,
            credentials: "include" /* OR 'same-origin' */,
          }),
      },
    );
  }

  private _remoteDB: PouchDB.Database;

  get remoteDB(): PouchDB.Database {
    return this._remoteDB;
  }

  getRemoteDB = () => {
    return this._remoteDB;
  };

  replicateToRemoteDB = async () => {
    return await this._localDB.replicate.to(this._remoteDB);
  };

  get = async (docId: string, hasAttachments = false) => {
    try {
      return await this._localDB.get(docId, {
        attachments: hasAttachments,
        binary: hasAttachments,
      });
    } catch (error) {
      return error;
    }
  };

  put = async (doc: any) => {
    try {
      return await this._localDB.put(doc);
    } catch (error) {
      return error;
    }
  };

  upsert = async (docId: string, data: any) => {
    try {
      const doc: any = await this._localDB?.upsert(docId, (res) => {
        return { ...res, ...data };
      });

      return await this.get(doc.id);
    } catch (error) {
      return error;
    }
  };

  remove = async (docId: string) => {
    try {
      const doc: any = await this._localDB?.get(docId);
      return this._localDB?.remove(doc._id, doc._rev);
    } catch (error) {
      return error;
    }
  };

  destroy = async () => {
    try {
      return await this._localDB.destroy();
    } catch (error) {
      return error;
    }
  };

  getAttachment = async (docId: string, filename: string, rev: string) => {
    try {
      return await this._localDB.getAttachment(docId, filename, { rev });
    } catch (error) {
      return error;
    }
  };

  addAttachment = async (
    docId: string,
    fileName: string,
    attachment: any,
    rev: string,
    type: string,
  ) => {
    console.log(docId, fileName, attachment, rev, type);

    try {
      const file = await this._localDB.putAttachment(
        docId,
        fileName,
        rev,
        attachment,
        type,
      );

      console.log(file);
      return file;
    } catch (error) {
      return error;
    }
  };

  startSync() {
    this.sync = this._localDB
      .sync(this._remoteDB, {
        live: true,
        retry: true,
        since: "now",
      })
      .on("change", (info) => {
        console.log("Sync change:", info);
      })
      .on("error", (err) => {
        console.error("Sync error:", err);
      });
  }

  stopSync = () => {
    this.sync.cancel();
  };
}
